<template>
  <div class="publication-card-container">
    <qm-card class="publication-card">
      <div class="header">
        <span v-show="publication.logo" v-bgi="publication.logo" class="logo" />
        <span class="name" :title="publication.name">
          {{ publication.name }}
        </span>
        <div class="version">{{ publication.scope.name }}</div>
        <!-- NOTICE: 11.27 设计变动，去掉了此处私有小程序的标识 -->
        <!-- <span
          v-show="publication.appId"
          v-bgi="`/static/icon/publication-icon/publication-status-private.svg`"
          class="private"
        /> -->
      </div>
      <div class="body">
        <Yesterday
          :publication-id="publication.id"
          :publication-info="publicationInfo"
        />
      </div>
      <div class="leg">
        <div class="left">
          <div class="tip" v-if="publicationInfo.pubType === 'content-podcast'">
            请新建播客小程序体验全新功能，杂志小程序播客功能将在之后停止支持。
          </div>
          <span v-else-if="publicationInfo.pubType === 'quiz'"
            >题库: {{ dailyData.libCount }}</span
          >
          <span v-else>栏目: {{ dailyData.magazineCount }}</span>
          <!--
            <span>评论 : {{ dailyData.commentCount || 0 }}</span>
            <span>文章 : {{ dailyData.articleCount || 0 }}</span>
            <span>成员 : {{ dailyData.memberCount || 0 }}</span>
          -->
        </div>
        <div class="right">
          <el-popover
            class="qr-code"
            placement="top-start"
            width="175"
            trigger="hover"
          >
            <img
              slot=""
              :src="publicationQrcode"
              style="width: 150px;height: 150px;"
              alt="二维码"
            />
            <img
              slot="reference"
              class="qr-code-img"
              src="/static/icon/icon-qrcode.svg"
              alt="qr-code"
            />
          </el-popover>
        </div>
      </div>
      <div class="footer">
        <div v-if="publicationStatus" class="indicator">
          <i class="indicator-dot" :class="publicationStatus.color" />
          <span>{{ publicationStatus.text }}</span>
        </div>
        <router-link
          style="margin-left: 16px"
          target="_blank"
          :to="`/${publication.pubType}/${publicationId}/`"
        >
          <qm-button text="进入小程序" />
        </router-link>
      </div>
    </qm-card>
  </div>
</template>

<script>
/* eslint-disable */
import QmCard from 'src/components/common/qm-card'
import Yesterday from 'src/components/publication/Yesterday'
import * as qm from 'src/utils/utils'
import * as api from 'src/api/index'
import publicationStatus from 'src/components/publication/publicationStatus.js'
/* eslint-enable */

export default {
  mixins: [publicationStatus],
  name: 'PublicationCard',
  components: {
    QmCard,
    Yesterday,
  },
  props: {
    publication: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dailyData: {},
      appInfo: null,
      publicationInfo: null,
    }
  },
  computed: {
    appId() {
      return this.$store.state.publicationInfo.appId || 'wx05790b1180642960'
    },
    publicationId() {
      return this.publication.id
    },
    publicationQrcode() {
      /* eslint-disable */
      const APP_QINGMANG = 'wx05790b1180642960'
      /* eslint-enable */
      if (
        this.publicationInfo.pubType === 'content' ||
        this.publicationInfo.pubType === 'podcast' ||
        this.publicationInfo.pubType === 'brand'
      ) {
        return qm.generateMinaCodeForPublication('page', this.publicationInfo)
      } else if (this.publicationInfo.pubType) {
        // prettier-ignore
        return 'http://statics03.qingmang.mobi/mina/wxacode/quiz/wx3e0a5430ef91b0e8'
      } else {
        return ''
      }
    },
  },
  created() {
    // 预加载二维码
    let img = document.createElement('img')
    img.onload = () => {
      img = null
    }
    this.init()
  },
  methods: {
    async init() {
      this.publicationInfo = this.publication
      if (!this.publicationInfo.id) {
        return
      }
      if (this.publicationInfo.pubType === 'quiz') {
        api
          .getQuizLibList(this.publicationInfo.id)
          .then(res => {
            this.$set(this.dailyData, 'libCount', res.libs.length)
          })
          .catch(err => {
            console.error(err)
            this.$set(this.dailyData, 'libCount', '')
          })
      } else {
        api
          .Ajax({
            url: '/v2/pool.column.count',
            data: {
              publication_id: this.publicationInfo.id,
            },
          })
          .then(res => {
            this.$set(this.dailyData, 'magazineCount', res.columnNumber)
          })
          .catch(err => {
            console.error(err)
            this.$set(this.dailyData, 'magazineCount', '')
          })
      }
      if (this.publication.appId) {
        await api
          .getAppInfo(this.publicationInfo.appId)
          .then(res => {
            if (res.ok) {
              this.$set(this.publicationInfo, 'appInfo', res.app)
            }
          })
          .catch(err => {
            console.error(err)
          })
      }
    },
  },
}
</script>

<style lang="scss">
.publication-card-container {
  width: 360px;
  height: 320px;
  overflow: visible;

  .publication-card {
    margin-top: 24px;
    padding: 0 24px;

    .header {
      position: relative;
      height: 56px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      .logo {
        flex: none;
        align-self: flex-end;
        margin-bottom: 16px;
        height: 64px;
        width: 64px;
        border-radius: 50%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover !important;
        box-shadow: 0 8px 12px -10px rgba(0, 0, 0, 0.5),
          0 2px 10px -12px rgba(0, 0, 0, 0.16);
      }

      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        z-index: 1;
        margin-left: 8px;
        font-size: 16px;
        height: 24px;
        line-height: 24px;
        font-weight: bold;
        margin-right: 100px;

        &:after {
          position: absolute;
          bottom: -2px;
          left: -2px;
          z-index: -1;
          content: '';
          background-color: #fdf0b4;
          width: calc(100% + 4px);
          height: 12px;
        }
      }
      .version {
        position: absolute;
        right: 0;
        font-weight: 600;
        color: #4a90e2;
      }
      .private {
        position: absolute;
        bottom: 7px;
        right: -31px;
        width: 54px;
        height: 35px;
      }
    }

    .body {
      display: flex;
      padding: 0;
    }

    .leg {
      display: flex;
      padding: 16px 0;
      border-top: 1px solid #eeeeee;

      .left {
        position: relative;
        width: 240px;
        display: flex;
        align-items: center;
        // flex-wrap: wrap;
        // justify-content: space-between;
        padding-right: 2px;
        .tip {
          font-size: 14px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
        }
        span {
          width: 100px;
          height: 21px;
        }
      }

      .right {
        position: relative;
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: flex-end;

        .qr-code {
          opacity: 0.3;

          .qr-code-img {
            width: 48px;
            height: 48px;
          }
        }

        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          height: calc(100% - 10px);
          width: 1px;
          background-color: #eeeeee;
        }
      }
    }

    .footer {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;
      border-top: 1px solid #eeeeee;

      .indicator {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 20px;
        color: #666666;

        .indicator-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          margin-right: 6px;

          &.online {
            background-color: #4ece3c;
          }

          &.offline {
            background-color: #868f99;
          }

          &.failed {
            background-color: #f84b1c;
          }

          &.reviewing {
            background-color: #f88d1c;
          }
        }

        .indication-info {
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
